import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import SettingsSection from './SettingsSection';

const LanguageContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const LanguageButton = styled.button`
  background: ${props => props.active ? 'linear-gradient(145deg, #6a11cb, #2575fc)' : '#f0f3f9'};
  color: ${props => props.active ? 'white' : '#4a6fa1'};
  border: none;
  border-radius: 10px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: ${props => props.active 
    ? '0 4px 8px rgba(37, 117, 252, 0.2)'
    : 'inset 2px 2px 5px rgba(0, 0, 0, 0.05), inset -2px -2px 5px rgba(255, 255, 255, 0.5)'};
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.active 
      ? '0 6px 12px rgba(37, 117, 252, 0.25)'
      : '0 4px 8px rgba(0, 0, 0, 0.1)'};
  }
`;

const LanguageSection = () => {
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  const languages = [
    { code: 'ru', name: 'Русский' },
    { code: 'uk', name: 'Українська' },
    { code: 'en', name: 'English' }
  ];

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    setCurrentLang(lang);
  };

  useEffect(() => {
    setCurrentLang(i18n.language);
  }, [i18n.language]);

  return (
    <SettingsSection 
      title={t('language_title')} 
      description={t('language_description')}
    >
      <LanguageContainer>
        {languages.map(lang => (
          <LanguageButton 
            key={lang.code}
            active={currentLang === lang.code}
            onClick={() => changeLanguage(lang.code)}
          >
            {lang.name}
          </LanguageButton>
        ))}
      </LanguageContainer>
    </SettingsSection>
  );
};

export default LanguageSection;